module.exports = __webpack_public_path__ + "img/journal_next.9c6a957a.svg";